<template>
	<router-view :layout="layout" />
</template>

<script>
import MainLayout from "./layouts/MainLayout.vue";
import LoginLayout from "./layouts/LoginLayout.vue";
import ResetLayout from "./layouts/ResetLayout.vue";

export default {
	name: "App",
	data() {
		return {
			// layout: "div",
			// outlay: "",
		};
	},
	computed: {
		layout() {
			const meta = this.$route.meta.layout;
			var outlay;
			if (meta == "Login") {
				outlay = LoginLayout;
			} else if (meta == "Reset") {
				outlay = LoginLayout;
			}

			return outlay;
		},
	},
};
</script>